import React, { useState } from "react";
import { Box, Button, Flex } from "rebass";
import Hanger from "../../icons/Hanger";
import Plus from "../../icons/Plus";
import { getLocalizedString } from "../../utils";
import { getLocalizedText } from "../../utils/getLocalizedText";
import { Price } from "../common/Price";
import TableSize from "./TableSize";
const ProductDescription = ({
  id,
  modelCode,
  catalogueItemDetails,
  materialCode,
  descriptionExpand,
  expandDescription,
  prices,
  buttonTableView,
  sx,
}) => {
  const [tableView, setTableView] = useState(false);
  const changeTableView = () => {
    setTableView(!tableView);
  };
  return (
    <Box sx={sx}>
      <div className="p-3 col-span-2">
        <div className="">
          {getLocalizedString("Nome modello")}: <strong>{modelCode}</strong>
        </div>
        <div className="">
          {getLocalizedString("Codice materiale")}:{" "}
          <strong>{catalogueItemDetails[id]?.materialCode}</strong>
        </div>
        <div className="">
          {getLocalizedString("Codice linea")}:{" "}
          <strong>{catalogueItemDetails[id]?.lineCode}</strong>
        </div>
        <div className="">
          {getLocalizedString("Descrizione linea")}:{" "}
          <strong>
            {getLocalizedText(catalogueItemDetails[id]?.lineDescription)}
          </strong>
        </div>
        <div className="">
          {getLocalizedString("Codice collezione")}:{" "}
          <strong>{catalogueItemDetails[id]?.collectionCode}</strong>
        </div>
        <div className="">
          {getLocalizedString("Collezione")}:{" "}
          <strong>
            {getLocalizedText(catalogueItemDetails[id]?.collectionDescription)}
          </strong>
        </div>

        <div className="pt-3">{getLocalizedString("Descrizione modello")}:</div>
        <div>
          <strong>
            {getLocalizedText(catalogueItemDetails[id]?.modelDescription)}
          </strong>
        </div>
        <br />

        <div className="">
          {getLocalizedString("Taglie")}:{" "}
          <strong>
            {catalogueItemDetails[id]?.sizes
              ?.sort?.((a, b) => a - b)
              ?.join?.(" | ") || ""}
          </strong>
        </div>
        <div>
          {getLocalizedString("Descrizione materiale")}:{" "}
          {getLocalizedText(catalogueItemDetails[id]?.materialDescription)}
        </div>
        <div>{getLocalizedString("Composizione materiale")}:</div>
        <div style={{ marginBottom: "5px" }}>
          {getLocalizedText(catalogueItemDetails[id]?.materialComposition)}
        </div>

        <Box
          sx={{
            height: "27px",
            width: "27px",
            borderRadius: "20px",
            cursor: "pointer",
            backgroundColor: descriptionExpand ? "rgba(255,255,255, .6)" : "",
            textDecoration: descriptionExpand ? "underline" : "",
            "& > svg": {
              height: "20px",
              width: "20px",
              position: "relative",
              left: "3px",
              top: "3px",
            },
            "&:hover": {
              backgroundColor: "rgba(255,255,255, .6)",
              textDecoration: "underline",
            },
          }}
          onClick={expandDescription}
        >
          <Plus></Plus>
          <Box
            style={{
              width: "300px",
              top: "-14.5px",
              position: "relative",
              fontSize: "0.8em",
              left: "30px",
            }}
          >
            {getLocalizedString("MORE DESCRIPTION")}
          </Box>

          <Box
            sx={{
              position: "absolute",
              display: descriptionExpand ? "" : "none",
              maxWidth: "460px",
              maxHeight: "250px",
              backgroundColor: "#ffffff",
              color: "black",
              bottom: "110px",
              fontSize: "0.9em",
              padding: "10px",
              overflow: "auto",
            }}
          >
            <Flex flexDirection={"column"} style={{ fontSize: "0.9em" }}>
              <Box style={{ fontWeight: "bold" }}>
                Material - {materialCode}
              </Box>
              <Box>
                <span style={{ fontWeight: "bold" }}>
                  {getLocalizedString("SKU_DESCRIPTION")}
                </span>{" "}
                {getLocalizedText(catalogueItemDetails?.[id]?.["sku"])}
              </Box>
              <Flex flexDirection={"row"} style={{ marginTop: "5px" }}>
                <Box style={{ width: "200px" }}>
                  <span style={{ fontWeight: "bold" }}>
                    {getLocalizedString("SHAPE")}
                  </span>{" "}
                  {getLocalizedText(catalogueItemDetails?.[id]?.["shape"]) ||
                    getLocalizedString("MOREDESCRIPTIONNOTFOUND")}
                </Box>
                <Box style={{ width: "200px" }}>
                  <span style={{ fontWeight: "bold" }}>
                    {getLocalizedString("POCKETS")}
                  </span>{" "}
                  {getLocalizedText(catalogueItemDetails?.[id]?.["pockets"]) ||
                    getLocalizedString("MOREDESCRIPTIONNOTFOUND")}
                </Box>
              </Flex>
              <Flex flexDirection={"row"} style={{ marginTop: "5px" }}>
                <Box style={{ width: "200px" }}>
                  <span style={{ fontWeight: "bold" }}>
                    {getLocalizedString("HOOD")}
                  </span>{" "}
                  {getLocalizedText(catalogueItemDetails?.[id]?.["hood"]) ||
                    getLocalizedString("MOREDESCRIPTIONNOTFOUND")}
                </Box>
                <Box style={{ width: "200px" }}>
                  <span style={{ fontWeight: "bold" }}>
                    {getLocalizedString("PADDING")}
                  </span>{" "}
                  {getLocalizedText(catalogueItemDetails?.[id]?.["padding"]) ||
                    getLocalizedString("MOREDESCRIPTIONNOTFOUND")}
                </Box>
              </Flex>
              <Flex flexDirection={"row"} style={{ marginTop: "5px" }}>
                <Box style={{ width: "200px" }}>
                  <span style={{ fontWeight: "bold" }}>
                    {getLocalizedString("SLEEVES")}
                  </span>{" "}
                  {getLocalizedText(catalogueItemDetails?.[id]?.["sleevs"]) ||
                    getLocalizedString("MOREDESCRIPTIONNOTFOUND")}
                </Box>
                <Box style={{ width: "200px" }}>
                  <span style={{ fontWeight: "bold" }}>
                    {getLocalizedString("TAG")}
                  </span>{" "}
                  {getLocalizedText(catalogueItemDetails?.[id]?.["tag"]) ||
                    getLocalizedString("MOREDESCRIPTIONNOTFOUND")}
                </Box>
              </Flex>
              <Flex flexDirection={"row"} style={{ marginTop: "5px" }}>
                <Box style={{ width: "200px" }}>
                  <span style={{ fontWeight: "bold" }}>
                    {getLocalizedString("FIT")}
                  </span>{" "}
                  {getLocalizedText(catalogueItemDetails?.[id]?.["fit"]) ||
                    getLocalizedString("MOREDESCRIPTIONNOTFOUND")}
                </Box>
                <Box style={{ width: "200px" }}>
                  <span style={{ fontWeight: "bold" }}>
                    {getLocalizedString("MADEIN")}
                  </span>{" "}
                  {getLocalizedText(catalogueItemDetails?.[id]?.["madeIn"]) ||
                    getLocalizedString("MOREDESCRIPTIONNOTFOUND")}
                </Box>
              </Flex>
              <Flex flexDirection={"row"} style={{ marginTop: "5px" }}>
                <Box style={{ width: "200px" }}>
                  <span style={{ fontWeight: "bold" }}>
                    {getLocalizedString("CLOSURE")}
                  </span>{" "}
                  {getLocalizedText(catalogueItemDetails?.[id]?.["closure"]) ||
                    getLocalizedString("MOREDESCRIPTIONNOTFOUND")}
                </Box>
                <Box style={{ width: "200px" }}>
                  <span style={{ fontWeight: "bold" }}>
                    {getLocalizedString("MATERIALDESCRIPTION")}
                  </span>{" "}
                  {getLocalizedText(
                    catalogueItemDetails?.[id]?.["materialDescription"], //ue
                  ) || getLocalizedString("MOREDESCRIPTIONNOTFOUND")}
                </Box>
              </Flex>
            </Flex>
          </Box>
        </Box>

        <Box>
          {buttonTableView && (
            <Button
              sx={{
                color: "rgb(0, 0, 0)",
                display: "flex",
                alignItems: "center",
                fontSize: "1em",
                textTransform: "uppercase",
                margin: "10px 0",
                background: "rgb(255, 255, 255)",
                cursor: "pointer",
              }}
              onClick={changeTableView}
            >
              <Hanger
                style={{
                  paddingRight: "5px",
                }}
              />
              <span>{getLocalizedString("FIND_YOUR_SIZE")}</span>
            </Button>
          )}
        </Box>
        {tableView && <TableSize onClose={changeTableView} />}

        <div style={{ paddingTop: "5px" }}>
          <strong>{getLocalizedString("Prezzo")}:</strong>
          <Price price={prices}></Price>
        </div>
      </div>
    </Box>
  );
};

export default ProductDescription;
